import React, { useState } from "react";
import { CalendarDays } from "lucide-react";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverTrigger, PopoverContent } from "./ui/popover";
import { prettyDate, istTodayStr } from "../lib/ist";

function toStr(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
function fromStr(s) {
  if (!s) return undefined;
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
}

export const DatePicker = ({ value, onChange, maxToday, testid, placeholder = "Select a date" }) => {
  const [open, setOpen] = useState(false);
  const selected = fromStr(value);
  const maxDate = maxToday ? fromStr(istTodayStr()) : undefined;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          className="w-full flex items-center gap-2 px-4 py-3 rounded-xl bg-black/50 border border-amber-500/25 text-left text-zinc-100 hover:border-amber-400/60 focus:outline-none focus:border-amber-400/70 transition-colors"
        >
          <CalendarDays className="w-4 h-4 ac-gold-text shrink-0" />
          <span className={selected ? "" : "text-zinc-500"}>
            {selected ? prettyDate(value) : placeholder}
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        data-testid={`${testid}-calendar`}
        className="ac-glass border-amber-500/25 text-zinc-100 w-auto p-0"
      >
        <Calendar
          mode="single"
          selected={selected}
          defaultMonth={selected || maxDate || new Date()}
          onSelect={(d) => {
            if (d) {
              onChange(toStr(d));
              setOpen(false);
            }
          }}
          disabled={maxDate ? { after: maxDate } : undefined}
          classNames={{
            day_selected:
              "bg-amber-500 text-black font-bold hover:bg-amber-500 hover:text-black focus:bg-amber-500 focus:text-black",
            day_today: "border border-amber-500/50 text-amber-300",
            day: "h-8 w-8 p-0 font-normal rounded-md text-zinc-200 hover:bg-amber-500/15 hover:text-amber-100 aria-selected:opacity-100",
            head_cell: "text-amber-400/70 rounded-md w-8 font-normal text-[0.8rem]",
            caption_label: "text-sm font-semibold text-amber-100",
            nav_button:
              "h-7 w-7 bg-transparent p-0 text-amber-300 opacity-70 hover:opacity-100 rounded-md border border-amber-500/25",
            day_disabled: "text-zinc-600 opacity-40",
          }}
        />
      </PopoverContent>
    </Popover>
  );
};
